/* JoMuh Conversion-Features: Merkliste (localStorage), Versandkostenfrei-Balken,
   Abo-Auswahl.
   Eingebunden in layout/theme.liquid. Kein Modul, keine Abhaengigkeiten. */
(function () {
  var KEY = 'jomuh:wishlist';

  /* Lieferzusage entfernt: Der Shop macht keine konkrete Tag-/Uhrzeit-Aussage mehr.
     Liefertexte stehen jetzt statisch und weich im HTML ("Meist in 1 bis 2 Werktagen"). */

  function list() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(l) { localStorage.setItem(KEY, JSON.stringify(l)); sync(); }
  function toggle(h) {
    var l = list();
    var i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); } else { l.push(h); }
    save(l);
  }

  function sync() {
    var l = list();
    document.querySelectorAll('[data-jomuh-wish]').forEach(function (btn) {
      var on = l.indexOf(btn.getAttribute('data-jomuh-wish')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = btn.querySelector('[data-wish-label]');
      if (lab) lab.textContent = on ? 'Gemerkt' : 'Merken';
    });
    document.querySelectorAll('[data-jomuh-wish-count]').forEach(function (b) {
      b.textContent = l.length;
      b.hidden = l.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jomuh-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-jomuh-wish'));
  }, true);

  /* Neue Knoten (Pagination, Section-Morphs) nachziehen */
  var syncTimer = null;
  new MutationObserver(function () {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 120);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Versandkostenfrei-Balken ---------- */
  function euro(cents) {
    /* Shop-Format: €12,34 */
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function updateShipbars(total) {
    document.querySelectorAll('[data-jomuh-shipbar]').forEach(function (bar) {
      var t = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!t) return;
      var rest = t - total;
      var pct = Math.max(0, Math.min(100, Math.round((total / t) * 100)));
      bar.classList.toggle('jomuh-shipbar--done', rest <= 0);
      var txt = bar.querySelector('[data-shipbar-text]');
      if (txt) txt.textContent = rest <= 0 ? 'Versandkostenfrei!*' : 'Noch ' + euro(rest) + ' bis Versandkostenfrei*';
      var fill = bar.querySelector('[data-shipbar-fill]');
      if (fill) fill.style.width = pct + '%';
    });
  }
  /* ---------- Mindestbestellwert-Gate (Setting jomuh_min_order via cart-summary.liquid) ----------
     ponytail: rein clientseitig. Sperrt Checkout-Button + Express-Checkout, wenn Warenwert < Schwelle.
     UNUMGEHBAR gegen direkte /checkout-URL waere nur eine Shopify Checkout-Validation-Function. */
  function updateMinOrder(total) {
    var box = document.querySelector('[data-jomuh-minorder]');
    if (!box) return;
    var min = parseInt(box.getAttribute('data-min'), 10) || 0;
    if (!min) return;
    var rest = min - total;
    var below = rest > 0;
    document.querySelectorAll('[data-jomuh-minorder]').forEach(function (b) {
      var t = b.querySelector('[data-minorder-text]');
      if (below) {
        b.hidden = false;
        if (t) t.textContent = 'Mindestbestellwert ' + euro(min) + '. Dir fehlen noch ' + euro(rest) + '.';
      } else {
        b.hidden = true;
      }
    });
    document.querySelectorAll('[data-jomuh-checkout]').forEach(function (btn) {
      if (below) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('jomuh-checkout-blocked');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('jomuh-checkout-blocked');
      }
    });
    document.querySelectorAll('[data-jomuh-accel]').forEach(function (el) {
      el.style.display = below ? 'none' : '';
    });
  }

  document.addEventListener('cart:update', function (e) {
    var c = e.detail && e.detail.resource;
    if (c && typeof c.total_price === 'number') {
      updateShipbars(c.total_price);
      updateMinOrder(c.total_price);
    } else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateShipbars(cart.total_price);
        updateMinOrder(cart.total_price);
      }).catch(function () {});
    }
  });

  /* ---------- Lieferzeit-Ampel + Abo-Block: bei Variantenwechsel aus frischem Section-HTML ersetzen ---------- */
  document.addEventListener('variant:update', function (e) {
    var html = e.detail && e.detail.data && e.detail.data.html;
    if (!html || !html.querySelector) return;
    ['[data-jomuh-ampel]', '[data-jomuh-abo-root]'].forEach(function (sel) {
      var fresh = html.querySelector(sel);
      var cur = document.querySelector(sel);
      if (fresh && cur) cur.replaceWith(fresh.cloneNode(true));
    });
    sync();
  });

  /* ---------- Abo-Auswahl (zooplus-Stil, nur wenn Selling Plans existieren) ---------- */
  document.addEventListener('change', function (e) {
    var root = e.target.closest('[data-jomuh-abo-root]');
    if (!root) return;
    var input = root.querySelector('[data-abo-input]');
    var sel = root.querySelector('[data-abo-plans]');
    var plan = false;
    root.querySelectorAll('input[name="jomuh-abo-choice"]').forEach(function (r) {
      var opt = r.closest('.jomuh-abo__opt');
      if (opt) opt.classList.toggle('is-checked', r.checked);
      if (r.checked && r.value === 'plan') plan = true;
    });
    if (input) input.value = plan && sel ? sel.value : '';
    var priceEl = root.querySelector('[data-abo-price]');
    if (priceEl && sel) {
      var o = sel.options[sel.selectedIndex];
      if (o && o.dataset.price) priceEl.textContent = o.dataset.price;
    }
  });

  /* ---------- Merklisten-Seite ---------- */
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function updateCartBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.remove('visually-hidden');
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (b) {
      b.textContent = count;
      b.classList.remove('hidden');
    });
  }

  var grid = document.getElementById('jomuh-wishlist-grid');

  function renderWishlist() {
    var l = list();
    var empty = document.getElementById('jomuh-wishlist-empty');
    if (!l.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      grid.innerHTML = '';
      return;
    }
    grid.hidden = false;
    if (empty) empty.hidden = true;
    Promise.all(l.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (prods) {
      grid.innerHTML = '';
      prods.forEach(function (p, i) {
        var h = l[i];
        var card = document.createElement('div');
        card.className = 'jomuh-wl-card';
        if (!p) {
          card.innerHTML =
            '<p class="jomuh-wl-card__gone">Dieses Produkt ist leider nicht mehr verfügbar.</p>' +
            '<button type="button" class="jomuh-wl-remove" data-wl-remove="' + esc(h) + '" aria-label="Entfernen">×</button>';
        } else {
          var v = null;
          (p.variants || []).some(function (x) { if (x.available) { v = x; return true; } return false; });
          if (!v && p.variants && p.variants.length) v = p.variants[0];
          card.innerHTML =
            '<button type="button" class="jomuh-wl-remove" data-wl-remove="' + esc(h) + '" aria-label="Von der Merkliste entfernen">×</button>' +
            '<a class="jomuh-wl-card__media" href="' + esc(p.url) + '">' +
            (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 360)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<a class="jomuh-wl-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="jomuh-wl-card__price">' + euro(p.price) + '</div>' +
            (p.available && v
              ? '<button type="button" class="jomuh-wl-add" data-wl-add="' + v.id + '">In den Warenkorb</button>'
              : '<span class="jomuh-wl-soldout">Aktuell ausverkauft</span>');
        }
        grid.appendChild(card);
      });
    });
  }

  if (grid) {
    renderWishlist();
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wl-remove]');
      if (rm) {
        var l = list();
        var i = l.indexOf(rm.getAttribute('data-wl-remove'));
        if (i > -1) { l.splice(i, 1); save(l); }
        renderWishlist();
        return;
      }
      var add = e.target.closest('[data-wl-add]');
      if (add && !add.disabled) {
        add.disabled = true;
        var original = add.textContent;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(add.getAttribute('data-wl-add'), 10), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js').then(function (r2) { return r2.json(); });
        }).then(function (cart) {
          updateCartBubble(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'jomuh-wishlist', data: { source: 'jomuh-wishlist', itemCount: cart.item_count } }
          }));
          add.textContent = 'Hinzugefügt ✓';
          setTimeout(function () { add.textContent = original; add.disabled = false; }, 2000);
        }).catch(function () {
          add.textContent = original;
          add.disabled = false;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();

